import { ConnectionsEmptyOrError } from '@terminal/modules/overview-knowledge-graph/components/shared/section-base/SectionBase';
import { useCompanyRegionExposure } from '@terminal/react-query-hooks/knowledge-graph/useKnowledgeGraph';
import { useTranslation } from 'react-i18next';

import { RankingMethodologySection } from '../../theme-exposure-tab/theme-exposure-table/ranking-methodology-section/RankingMethodologySection';
import { GeographicExposureTable } from '../components/GeographicExposureTable';
import { useGeographicDrawer } from '../drawers/useGeographicDrawer';
import styles from './GeographicExposureSubTab.module.scss';

export interface RegionalExposureTabProps {
  entityTag: string;
}

export const RegionalExposureTab = ({
  entityTag,
}: RegionalExposureTabProps) => {
  const { t } = useTranslation(['widget']);
  const { openRegion } = useGeographicDrawer({ entityTag });

  const {
    data = [],
    isSuccess,
    isError,
    isFetching,
  } = useCompanyRegionExposure({
    entityTag,
    enabled: !!entityTag,
  });

  if (isError) {
    return (
      <div className={styles.subTabRoot}>
        <div className={styles.tabContent}>
          <ConnectionsEmptyOrError variant="error" errorSize="fullView" />
        </div>
        <RankingMethodologySection rankingType="companyToGeographicExposure" />
      </div>
    );
  }

  if (isSuccess && !isFetching && data.length === 0) {
    return (
      <div className={styles.subTabRoot}>
        <div className={styles.tabContent}>
          <ConnectionsEmptyOrError
            variant="empty"
            layout="fillContainer"
            imageSize="full"
            title={t(
              'widget:assetOverview.knowledgeGraphRevamp.empty.geographicExposure'
            )}
          />
        </div>
        <RankingMethodologySection rankingType="companyToGeographicExposure" />
      </div>
    );
  }

  return (
    <GeographicExposureTable
      mode="region"
      data={data}
      isFetching={isFetching}
      onRowClick={openRegion}
    />
  );
};
